import React, { FC, memo, useMemo } from 'react'
import { Answer, Container, ContentWrapper, CustomMarkdown, FAQItem, Question, TitleSubtitleWrapper } from './styles'
import { FAQTransport } from '../../../transports/region-landing-page-transport'
import { useTranslation } from '../../../hooks/locale'
import { Subtitle, Title } from '../common/styles'

interface FaqsProps {
    faqs: FAQTransport[]
    location: string
}

const getRichSnippetHtml = (faqs: FAQTransport[]) => {
    const QASchema = faqs.map(faq => {
        return {
            '@type': 'Question',
            name: faq.question,
            acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
            },
        }
    })

    return {
        __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: QASchema,
        }),
    }
}

const FAQSection: FC<FaqsProps> = ({ faqs, location }) => {
    const { t } = useTranslation()
    const faqSectionSubtitle = `${t('faqSubTitle')} ${location}`
    const richSnippetHtml = useMemo(() => getRichSnippetHtml(faqs), [faqs])

    return (
        <Container id="faqs">
            <script type="application/ld+json" dangerouslySetInnerHTML={richSnippetHtml} />
            <TitleSubtitleWrapper>
                <Title>{t('faqsTitle')}</Title>
                <Subtitle>{faqSectionSubtitle}</Subtitle>
            </TitleSubtitleWrapper>
            <ContentWrapper>
                {faqs.map(
                    faq =>
                        faq.question &&
                        faq.answer && (
                            <FAQItem key={faq.question}>
                                <Question>{faq.question}</Question>
                                <Answer>
                                    <CustomMarkdown>{faq.answer}</CustomMarkdown>
                                </Answer>
                            </FAQItem>
                        ),
                )}
            </ContentWrapper>
        </Container>
    )
}

export default memo(FAQSection)
